"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const TimeOnly_1 = tslib_1.__importDefault(require("./TimeOnly"));
const LabeledInputFieldWidget_1 = tslib_1.__importDefault(require("../widget/LabeledInputFieldWidget"));
const InputEventUtil_1 = tslib_1.__importDefault(require("../util/InputEventUtil"));
class WCAGTimeField extends LabeledInputFieldWidget_1.default {
    constructor(args) {
        super({
            ...args,
            fieldSizeClass: args.fieldSizeClass || "field-size-time",
            hint: args.hint || "(tt:mm)",
            inputType: "text"
        });
        this.separators = [":", "."];
    }
    setDate(date, fireEvents = false) {
        const timeOnly = !!date ? new TimeOnly_1.default(date.getHours(), date.getMinutes()) : undefined;
        this.setValue(timeOnly, fireEvents);
    }
    isValidInputString(value) {
        if (fmko_ts_common_1.StringUtils.isEmpty(value)) {
            return true;
        }
        return this._isValid(value, false);
    }
    parseFieldElementValue(value) {
        if (fmko_ts_common_1.StringUtils.isEmpty(value)) {
            return null;
        }
        else {
            return TimeOnly_1.default.fromXmlTimeValue(value);
        }
    }
    decorateLabeledInputFieldWidgetElement(args) {
        this.element = document.createElement("div");
        this.element.classList.add("time-field");
        this.init();
        this.add(this.labelElement);
        this.add(this.fieldElement);
        this.add(this.hintElement);
    }
    setFieldElementValue(value) {
        this.fieldElement.value = !value ? "" : value.getStringValue();
    }
    onBeforeInput(event) {
        if (InputEventUtil_1.default.isDeletingText(event)) {
            return;
        }
        let ch = InputEventUtil_1.default.getChar(event);
        if (ch === ".") {
            // Allow ".". Replace with ":" in ValueChangeHandler below..
            ch = ":";
        }
        if (ch === ":") {
            event.preventDefault();
        }
        const pos = this.fieldElement.selectionStart;
        const fieldValue = this.fieldElement.value;
        if (!this.isValidNextChar(fieldValue, ch, pos)) {
            if (pos === 1 && ch === ":") {
                // 1 + ":" -> 01:
                this.fieldElement.value = fieldValue.substring(0, fieldValue.length - 1)
                    + "0"
                    + fieldValue.substring(fieldValue.length - 1, fieldValue.length);
            }
            else {
                // Illegal character at this point
                event.preventDefault();
                return;
            }
        }
        else {
            if (this.fieldElement.value.length === pos) {
                // Cursor is at end of text
                if (pos === 1) {
                    // Auto append ":" character
                    ch = ":";
                }
            }
        }
        if (ch === ":") {
            this.appendMinutesAsZerosAndFocus();
        }
    }
    onInput(event) {
        if (!InputEventUtil_1.default.isInsertingText(event)) {
            return;
        }
    }
    onPaste(event) {
        super.onPaste(event);
        this.fixTime();
    }
    isValidNextChar(currentValue, char, selectionStart = null, selectionEnd = null) {
        if ((char < "0" || char > "9") && !this.separators.includes(char)) {
            return false;
        }
        switch (selectionStart) {
            case 0:
            case 1:
                return char !== ":";
            case 2:
                return char === ":";
            case 3:
            case 4:
                return char !== ":";
            case 5:
                return false;
            default:
                return false;
        }
    }
    init() {
        this.addOnBlurHandler(() => this.fixTime());
    }
    fixTime(focusMinutes) {
        const val = this.getFieldElement().value;
        if (val != null) {
            let v = val.replace(".", ":");
            // Check if all digits
            if (fmko_ts_common_1.StringUtils.onlyContainsDigits(v) && v.length === 4) {
                // hhmm -> hh:mm
                v = v.substring(0, 2) + ":" + v.substring(2);
            }
            else {
                // Convert 1:12 -> 01:12
                if (v.length >= 3) {
                    if (fmko_ts_common_1.StringUtils.onlyContainsDigits(v.charAt(0)) && v.charAt(1) === ":") {
                        v = "0" + v;
                    }
                }
                // Convert 1 -> 01
                if (v.length === 1 && fmko_ts_common_1.StringUtils.onlyContainsDigits(v.charAt(0))) {
                    v = "0" + v;
                }
                if ((v.length === 2 || v.length === 3) && this._isValid(v, true)) {
                    // Valid hour but minutes are missing
                    if (v.length === 2) {
                        v += ":";
                    }
                    v = v + "00";
                }
            }
            if (val !== v && this._isValid(v, true)) {
                this.getFieldElement().value = v;
            }
        }
        const newValue = this.parseFieldElementValue(this.fieldElement.value);
        fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, this.value, newValue);
        this.value = newValue;
    }
    _isValid(value, acceptPartial) {
        if (acceptPartial) {
            return super.isValidInputString(value);
        }
        // DateTimeFormat is too forgiving..
        const hour = parseInt(value.substring(0, 2), 10);
        if (hour < 0 || hour > 23) {
            return false;
        }
        const minutes = parseInt(value.substring(3, 5), 10);
        if (minutes < 0 || minutes > 59) {
            return false;
        }
        return true;
    }
    appendMinutesAsZerosAndFocus() {
        setTimeout(() => {
            this.fieldElement.value = `${this.fieldElement.value}:`;
            if (this.fieldElement.value.length === 3) {
                // Only minutes are missing now - auto append "00", and make them selected
                this.fieldElement.value = `${this.fieldElement.value}00`;
                this.fieldElement.setSelectionRange(3, 5);
            }
        });
    }
}
exports.default = WCAGTimeField;
//# sourceMappingURL=WCAGTimeField.js.map